<div class="Main-header" *ngIf="!db.ismobile">
  <ion-buttons slot="start">
    <ion-menu-button></ion-menu-button>
  </ion-buttons>
  <div class="logo">
    <img src="assets/logo-new-white.svg" alt="">
  </div>
  <!-- <div> -->
  <ion-searchbar *ngIf="false && !db.ismobile" #search animated></ion-searchbar>
  <!-- </div> -->
  <!-- <div class="d__flex" >
      <div class="settings_bell">
        <ion-icon slot="end" src="/assets/icon/settings-04.svg"></ion-icon>
        <ion-icon slot="end" src="/assets/icon/notifications-04.svg"></ion-icon>
      </div>
      <div> -->

  <div class="user_name d__flex gap-5">
    <ion-item class="user_name" lines="none" slot="end" class="mouse">
      <ion-icon class="mr10" name="person-outline"></ion-icon>
      <ion-label class="w-200">{{db.cust_name}}</ion-label>
    </ion-item>
  
    <ion-item lines="none" slot="end" class="mouse" (click)="logout()">
      <ion-icon class="mr10" src="assets/collapes-menu/logout-white.svg"></ion-icon>
      <ion-label>Logout</ion-label>
    </ion-item>
  </div>

</div>
